import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomField } from 'src/app/core/models/custom-fields.models';
import { BackendService } from 'src/app/core/services/backend/backend.service';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsBackendService {
  constructor(private bs: BackendService) {}

  public save(field: Partial<CustomField>): Observable<CustomField> {
    return field.id ? this.update(field as CustomField) : this.add(field);
  }

  public update(field: CustomField): Observable<CustomField> {
    const url = field.isForCompany ? `company/custom/${field.id}` : `iportal/idea_custom/${field.id}`;
    return this.bs.put(url, field).pipe(map((serverField) => ({ ...serverField, ...field })));
  }

  public add(field: Partial<CustomField>): Observable<CustomField> {
    const url = field.isForCompany ? `company/custom` : `iportal/idea_custom/`;
    return this.bs.post(url, field).pipe(map((serverField) => ({ ...serverField, ...field })));
  }

  public delete(field: CustomField): Observable<void> {
    const url = field.isForCompany ? `company/custom/${field.id}` : `iportal/idea_custom/${field.id}`;
    return this.bs.delete(url).pipe(map(() => {}));
  }

  public formList(): Observable<readonly CustomField[]> {
    return this.bs.get(`iportal/custom_fields`).pipe(
      map((res) => {
        return (res || []).map(
          (cf: CustomField): CustomField => ({
            ...cf,
            isForCompany: false,
          }),
        );
      }),
    );
  }

  public companyList(): Observable<readonly CustomField[]> {
    return this.bs.get(`company/custom`).pipe(
      map((res) => {
        return (res.list || []).map(
          (cf: CustomField): CustomField => ({
            ...cf,
            isForCompany: true,
          }),
        );
      }),
    );
  }
}
